// extracted by mini-css-extract-plugin
module.exports = {"container":"App_container__1MQN3","image":"App_image__3byI1","image2":"App_image2__1ithZ"};